"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _toConsumableArray2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.array.sort");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es7.object.values");
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _menuTemplate = require("@/api/goods/menuTemplate");
var _dishGroup = require("@/api/goods/dishGroup");
var _goods = require("@/api/goods/goods");
var _menuStoreTemplate = require("@/api/goods/menuStoreTemplate");
var _SwPage = _interopRequireDefault(require("@/views/common/SwPage"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 水波纹指令
var _default = exports.default = {
  name: 'detail',
  props: ['templateId'],
  components: {
    SwPage: _SwPage.default
  },
  directives: {
    waves: _waves.default
  },
  data: function data() {
    return {
      listLoading: false,
      resPath: '',
      selectScene: null,
      selectGroup: null,
      selectedScenes: [],
      // 控制场景显示的多选数组
      baseInfo: {
        checkedScene: []
      },
      dishGroups: [],
      templateGroupItems: [],
      groupAddVisible: false,
      groupAddQuery: {
        page: 1,
        limit: 1000,
        keywords: null
      },
      groupAddData: [],
      itemTotal: 0,
      itemAddVisible: false,
      itemAddQuery: {
        page: 1,
        limit: 10,
        keywords: null,
        dataType: 'templateGroupItem',
        dataId: null
      },
      itemAddTotal: 0,
      itemAddData: [],
      fullscreenLoading: false,
      editVisible: false,
      editForm: {},
      selectedItemsMap: {} // 用于存储每个表格的选中项
    };
  },
  created: function created() {
    this.getBaseInfo();
  },
  computed: {
    // 获取所有选中的项
    allSelectedItems: function allSelectedItems() {
      return Object.values(this.selectedItemsMap).flat();
    }
  },
  methods: {
    handleBatchChangeStatus: function handleBatchChangeStatus(status) {
      var _this = this;
      var ids = this.getAllSelectedIds();
      this.$confirm('确认更新状态吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _menuStoreTemplate.batchChangeStatus)({
          ids: ids,
          status: status
        }).then(function (res) {
          if (res.code == 0) {
            _this.$message.success('操作成功');
            _this.handleSceneSelect();
          }
        });
      }).catch(function () {});
    },
    // 修改 handleSelectionChange 方法
    handleSelectionChange: function handleSelectionChange(selectedRows, detail) {
      // 使用表格的 key（即 detail.id）来区分不同表格的选中项
      this.$set(this.selectedItemsMap, detail.id, selectedRows);
    },
    // 获取所有选中项的 ID
    getAllSelectedIds: function getAllSelectedIds() {
      return this.allSelectedItems.map(function (item) {
        return item.id;
      });
    },
    // 清空所有选中项
    clearAllSelection: function clearAllSelection() {
      var _this2 = this;
      this.selectedItemsMap = {};
      // 安全地清空表格实际选中状态
      this.templateGroupItems.forEach(function (detail) {
        var tableRef = _this2.$refs["table_".concat(detail.id)];
        if (tableRef && tableRef.length > 0) {
          tableRef[0].clearSelection();
        }
      });
    },
    saveEntity: function saveEntity() {
      var _this3 = this;
      (0, _menuStoreTemplate.saveStoreGroupItem)(this.editForm).then(function (res) {
        _this3.$message.success('操作成功');
        _this3.editVisible = false;
        _this3.handleSceneSelect();
      });
    },
    handleEdit: function handleEdit(id) {
      var _this4 = this;
      (0, _menuStoreTemplate.getStoreGroupItem)(id).then(function (res) {
        _this4.editForm = res.data;
        _this4.editVisible = true;
      });
    },
    handleTableSortChange: function handleTableSortChange(sort, detail) {
      if (!sort || !sort.prop || !sort.order) {
        return;
      }
      var direction = sort.order === 'ascending' ? 1 : -1;
      var prop = sort.prop;
      if (Array.isArray(detail.items)) {
        detail.items = (0, _toConsumableArray2.default)(detail.items).sort(function (a, b) {
          var va = a[prop];
          var vb = b[prop];
          if (va == null && vb == null) return 0;
          if (va == null) return -1 * direction;
          if (vb == null) return 1 * direction;
          if (typeof va === 'number' && typeof vb === 'number') {
            return (va - vb) * direction;
          }
          return String(va).localeCompare(String(vb)) * direction;
        });
      }
    },
    handleGroupDelete: function handleGroupDelete(id) {
      var _this5 = this;
      this.$confirm('确认删除分组吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _menuTemplate.deleteTemplateDishGroup)(id).then(function (res) {
          _this5.handleItemAddFilter();
          _this5.$message.success('操作成功');
          // 刷新分组列表和模板分组数据
          (0, _menuStoreTemplate.getStoreTemplateGroup)({
            storeTemplateId: _this5.templateId,
            scene: _this5.selectScene
          }).then(function (res) {
            _this5.dishGroups = res.data;
          });
          _this5.handlegetStoreTemplateGroupItems();
        });
      }).catch(function () {});
    },
    handleGroupItemDelete: function handleGroupItemDelete(id) {
      var _this6 = this;
      this.$confirm('确认删除商品吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _menuTemplate.deleteGroupItem)(id).then(function (res) {
          _this6.handleItemAddFilter();
          _this6.$message.success('操作成功');
          // 刷新当前分组的数据
          _this6.handlegetStoreTemplateGroupItems();
        });
      }).catch(function () {});
    },
    retPage: function retPage() {
      this.handleItemAddFilter();
    },
    handleAddGroupItem: function handleAddGroupItem(groupId) {
      this.itemAddQuery.dataId = groupId;
      this.handleItemAddFilter();
      this.itemAddVisible = true;
    },
    handleItemAddFilter: function handleItemAddFilter() {
      var _this7 = this;
      this.listLoading = true;
      (0, _goods.queryList)(this.itemAddQuery).then(function (response) {
        if (response) {
          _this7.itemAddData = response.records;
          _this7.itemAddTotal = response.total;
        }
        setTimeout(function () {
          _this7.listLoading = false;
        }, 0.5 * 1000);
      }, function () {
        setTimeout(function () {
          _this7.listLoading = false;
        }, 0.5 * 1000);
      });
    },
    addGoods: function addGoods(goodsId) {
      var _this8 = this;
      this.$confirm('确认添加此商品吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _menuStoreTemplate.saveStoreGroupItem)({
          goodsId: goodsId,
          templateGroupId: _this8.itemAddQuery.dataId
        }).then(function (res) {
          _this8.listLoading = false;
          _this8.$message.success('操作成功');
          // 刷新当前分组的数据
          _this8.handlegetStoreTemplateGroupItems();
          // 关闭添加商品对话框
          _this8.itemAddVisible = false;
        });
      }).catch(function () {});
    },
    handleStatusChange: function handleStatusChange(value, row) {
      var _this9 = this;
      this.listLoading = true;
      (0, _menuStoreTemplate.saveStoreGroupItem)({
        id: row.id,
        status: value
      }).then(function (res) {
        _this9.listLoading = false;
        _this9.$message.success('操作成功');
      });
    },
    handlegetStoreTemplateGroupItems: function handlegetStoreTemplateGroupItems(id) {
      var _this0 = this;
      (0, _menuStoreTemplate.getStoreTemplateGroupItems)({
        storeTemplateId: this.templateId,
        scene: this.selectScene,
        id: id
      }).then(function (res) {
        _this0.templateGroupItems = res.data;
      });
    },
    addGroup: function addGroup(groupId) {
      var _this1 = this;
      this.$confirm('确认添加此分组吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _menuTemplate.addTemplateDishGroup)({
          templateId: _this1.templateId,
          groupId: groupId,
          scene: _this1.selectScene
        }).then(function (res) {
          if (res.code === 0) {
            _this1.$message.success('添加成功');
            _this1.handleGroupAddFilter();
            // 刷新分组列表和模板分组数据
            (0, _menuStoreTemplate.getStoreTemplateGroup)({
              templateId: _this1.templateId,
              scene: _this1.selectScene
            }).then(function (res) {
              _this1.dishGroups = res.data;
            });
            _this1.handlegetStoreTemplateGroupItems();
            // 关闭添加分组对话框
            _this1.groupAddVisible = false;
          }
        });
      }).catch(function () {});
    },
    handleGroupAddFilter: function handleGroupAddFilter() {
      var _this10 = this;
      this.listLoading = true;
      (0, _dishGroup.queryList)({
        dataType: 'menuTemplate',
        dataId: this.templateId,
        scene: this.selectScene,
        keywords: this.groupAddQuery.keywords
      }).then(function (res) {
        _this10.groupAddData = res.records;
        _this10.listLoading = false;
      });
    },
    handleGroupAddVisible: function handleGroupAddVisible() {
      this.handleGroupAddFilter();
      this.groupAddVisible = true;
    },
    handleGroupSelectAll: function handleGroupSelectAll() {
      this.handlegetStoreTemplateGroupItems();
    },
    handleGroupSelect: function handleGroupSelect(key, keyPath) {
      this.handlegetStoreTemplateGroupItems(key);
    },
    handleSceneSelect: function handleSceneSelect(key, keyPath) {
      var _this11 = this;
      if (key) {
        this.selectScene = key;
      }
      (0, _menuStoreTemplate.getStoreTemplateGroup)({
        storeTemplateId: this.templateId,
        scene: this.selectScene
      }).then(function (res) {
        _this11.dishGroups = res.data;
      });
      this.handlegetStoreTemplateGroupItems();
    },
    getBaseInfo: function getBaseInfo() {
      var _this12 = this;
      (0, _menuStoreTemplate.getById)(this.templateId).then(function (res) {
        _this12.baseInfo = res.data;
        // 初始化选中的场景，从baseInfo.checkedScene复制到selectedScenes
        _this12.selectedScenes = (0, _toConsumableArray2.default)(_this12.baseInfo.checkedScene || []);

        // 如果控制块中有勾选的场景，默认选中第一个
        if (_this12.selectedScenes.length > 0) {
          _this12.handleSceneSelect(_this12.selectedScenes[0]);
        }
      });
    },
    // 处理场景控制多选框变化
    handleSceneControlChange: function handleSceneControlChange(selectedValues) {
      this.selectedScenes = selectedValues;
      // 如果当前选中的场景不在新的选中列表中，清空当前选择
      if (this.selectScene && !this.selectedScenes.includes(this.selectScene)) {
        this.selectScene = null;
        this.dishGroups = [];
        this.templateGroupItems = [];
      }

      // 如果控制块中有勾选的场景且当前没有选中任何场景，自动选中第一个
      if (this.selectedScenes.length > 0 && !this.selectScene) {
        this.handleSceneSelect(this.selectedScenes[0]);
      }
    }
  }
};